
import { defineComponent } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import SmtpSettings from "@/helpers/pages/SmtpSettings";
import { store } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import Swal from "sweetalert2";
import { Field, Form, ErrorMessage } from "vee-validate";
import * as Yup from "yup";

export default defineComponent({
  name: "SmtpSettings",
  components: { AgCard, Field, Form, ErrorMessage },
  data() {
    const schema = Yup.object().shape({
      server: Yup.string().required().label("Server"),
      port: Yup.number().required().positive().min(1).max(65353).label("Port"),
      email: Yup.string().email().required().label("Email"),
      password: Yup.string().required().label("Password"),
    });
    const schemeSendGrid = Yup.object().shape({
      apiKey: Yup.string().required().max(255).label("Api Key"),
      email: Yup.string().email().required().label("Email"),
    });

    return {
      module: SmtpSettings,
      schema,
      schemeSendGrid,
      compKey: 0,
      options: [
        {
          name: "SMTP",
          key: "smtp",
        },
        {
          name: "Sendgrid",
          key: "sendgrid",
        },
      ],
      formType: "smtp",
      formValues: {
        id: "",
        server: "",
        port: "",
        email: "",
        password: "",
        apiKey: "",
      },
    };
  },
  computed: {
    smtpSettings: function () {
      return store.getters.smtpSettings;
    },
  },
  mounted() {
    store.dispatch(GeneralActionTypes.GET_SMTP_SETTINGS).then(() => {
      if (this.smtpSettings) {
        this.formValues.apiKey = this.smtpSettings.apiKey;
        this.formValues.id = this.smtpSettings.id;
        this.formValues.server = this.smtpSettings.server;
        this.formValues.port = this.smtpSettings.port;
        this.formValues.email = this.smtpSettings.email;
        this.formValues.password = this.smtpSettings.password;
        this.formType = this.smtpSettings.type;
        ++this.compKey;
      }
    });
  },
  methods: {
    validateEmail(value: any) {
      if (!value) {
        return "This field is required";
      }
      const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!regex.test(value)) {
        return "This field must be a valid email";
      }
      return true;
    },
    onSubmit(values: any) {
      Swal.fire({
        title: "Are You Sure?",
        text: "You are about to update the E-Mail setting!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Save",
      }).then((result) => {
        if (result.isConfirmed) {
          const company = store.getters.company;
          let data = {
            ...values,
            companyGuid: company.companyGuid,
          };
          if (this.formValues.id) {
            data.id = this.formValues.id;
          }

          data.type = this.formType;
          store
            .dispatch(GeneralActionTypes.UPDATE_SMTP_SETTINGS, data)
            .then((response: any) => {
              if (Number(response.status) != 200) {
                Swal.fire("Error", response.Errors, "error");
              } else {
                Swal.fire(
                  "Success!",
                  "E-Mail settings has been updated!",
                  "success"
                );
              }
            })
            .catch((e: any) => {
              Swal.fire("Error", JSON.stringify(e.Message), "error");
            });
        }
      });
    },
  },
});
